var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('intro'),(!_vm.loader)?_c('div',[_c('firstCarouselSection',{attrs:{"trustedBy":_vm.trustedBy}}),_c('secondSection'),_c('thirdSection'),_c('fourthSection'),_c('secondCarouselSection'),_c('fifthSection')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }